export enum Breakpoint {
  SmallMobile = '(max-width: 480px)',
  Mobile = '(max-width: 768px)',
  Tablet = '(max-width: 1024px)',
  SmallDesktop = '(max-width: 1200px)',
  Desktop = '(max-width: 1440px)',
  BigDesktop = '(max-width: 1600px)',
}
